import { createApp } from 'vue'
import App from './App.vue'
import router from './config/router'
import store from './config/store'
import i18nConfig from './config/i18nConfig';

import "@/assets/css/teres.scss"


createApp(App)
  .use(store)
  .use(router)
  .use(i18nConfig)
  .mount('#app-teres')
